// 확증임상 혈당 엑셀 변환 - 날짜 탭(예: 1019) → 대상자별 탭(예: 2608096_L(5번 대상자))
// 브라우저(변환 페이지)와 Node(검증)에서 같이 쓰는 핵심 로직. ExcelJS 워크북 객체를 받는다.
(function (root) {
  const DATE_TAB = /^\s*\d{4}\s*$/;

  function normSensor(v) {
    if (v === null || v === undefined) return null;
    const m = String(v).match(/(\d{7})\s*[-_ ]\s*([LR])/i);
    return m ? m[1] + "_" + m[2].toUpperCase() : null;
  }

  // 셀 값 꺼내기(수식이면 결과값, 리치텍스트면 글자)
  function val(cell) {
    let v = cell && cell.value;
    if (v && typeof v === "object" && !(v instanceof Date)) {
      if ("result" in v) v = v.result;
      else if (v.richText) v = v.richText.map((t) => t.text).join("");
      else if ("text" in v) v = v.text;
    }
    return v === undefined ? null : v;
  }

  // 채혈번호 - 1차 날짜 탭의 '1-34' → '34', 엑셀이 날짜로 바꾼 '1-1'(2026-01-01) → '1'
  function normNo(v) {
    if (v === null || v === undefined || v === "") return null;
    if (v instanceof Date) return String(v.getUTCDate());
    if (typeof v === "number") return Number.isInteger(v) ? String(v) : String(v);
    const m = String(v).match(/^\s*\d+\s*-\s*(\d+)\s*$/);
    return m ? m[1] : String(v).trim();
  }

  // 시각 → 'HH:MM' (엑셀 시간은 1899-12-30 기준 Date 또는 하루 비율 숫자)
  function hhmm(v) {
    if (v instanceof Date) {
      return String(v.getUTCHours()).padStart(2, "0") + ":" + String(v.getUTCMinutes()).padStart(2, "0");
    }
    if (typeof v === "number") {
      const mins = Math.round((v % 1) * 1440);
      return String(Math.floor(mins / 60)).padStart(2, "0") + ":" + String(mins % 60).padStart(2, "0");
    }
    const m = v && String(v).match(/(\d{1,2}):(\d{2})/);
    return m ? m[1].padStart(2, "0") + ":" + m[2] : null;
  }

  function timeCellValue(hm) {
    const [h, m] = hm.split(":").map(Number);
    return new Date(Date.UTC(1899, 11, 30, h, m, 0));
  }

  // 날짜 탭 하나 → [{mmdd, no, hm, sensor, ysi, s1, s2, s3}]
  function readDateSheet(ws) {
    const mmdd = ws.name.trim();
    let headRow = null, cols = null;
    for (let r = 1; r <= 8 && !headRow; r++) {
      const row = ws.getRow(r);
      const texts = [];
      for (let c = 1; c <= Math.max(ws.columnCount, 12); c++) texts[c] = String(val(row.getCell(c)) || "");
      if (texts.some((t) => t.includes("채혈번호"))) {
        const find = (f) => texts.findIndex((t) => t && f(t));
        cols = {
          no: find((t) => t.includes("채혈번호")),
          t: find((t) => t.includes("채혈시간")),
          who: find((t) => t === "대상자" || t === "환자"),
          ysi: find((t) => t.includes("YSI")),
          smbg: find((t) => t.includes("SMBG")),
        };
        headRow = r;
      }
    }
    if (!headRow) return [];
    const out = [];
    let curNo = null, curT = null;
    for (let r = headRow + 2; r <= ws.rowCount; r++) {
      const row = ws.getRow(r);
      const no = val(row.getCell(cols.no)), t = val(row.getCell(cols.t));
      if (no !== null && no !== "") curNo = normNo(no);
      if (t !== null && t !== "") curT = hhmm(t) || curT;
      const s = normSensor(val(row.getCell(cols.who)));
      if (!s || !curT) continue;
      const rec = {
        mmdd, no: curNo, hm: curT, sensor: s,
        ysi: val(row.getCell(cols.ysi)),
        s1: val(row.getCell(cols.smbg)), s2: val(row.getCell(cols.smbg + 1)), s3: val(row.getCell(cols.smbg + 2)),
      };
      // 값 없는 줄(R) → 같은 묶음 바로 위 줄(짝 L) 값. 한 묶음에 대상자 2명이 있어 '첫 줄'이 아니라 '바로 위'
      const prev = out[out.length - 1];
      const empty = (x) => x.ysi === null && x.s1 === null && x.s2 === null && x.s3 === null;
      if (empty(rec) && prev && prev.mmdd === rec.mmdd && prev.no === rec.no && prev.hm === rec.hm) {
        rec.ysi = prev.ysi; rec.s1 = prev.s1; rec.s2 = prev.s2; rec.s3 = prev.s3;
      }
      out.push(rec);
    }
    return out;
  }

  // 혈당값 CSV(개인용 웹 '혈당값 다운로드': time,glucose / 'YYYY-MM-DD HH:mm:ss,값') → {'MM-DD HH:MM': 값}
  function parseGlucoseCsv(text) {
    const map = {};
    text.replace(/^﻿/, "").split(/\r?\n/).forEach((line) => {
      const m = line.match(/^\s*\d{4}-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::\d{2})?\s*,\s*([-\d.]+)/);
      if (m) map[`${m[1]}-${m[2]} ${m[3]}:${m[4]}`] = Number(m[5]);
    });
    return map;
  }

  function lastFilledRow(ws) {
    let last = 2;
    for (let r = 3; r <= ws.rowCount; r++) {
      const row = ws.getRow(r);
      if (val(row.getCell(1)) !== null || val(row.getCell(2)) !== null) last = r;
    }
    return last;
  }

  // target = 대상자별 탭 워크북(읽기용), dayBooks = 날짜 탭 워크북들, agms = {sensor: {'MM-DD HH:MM': 값}}
  // 반환 plan = { [탭 이름]: { rows: [{r, cells:[{col, kind, v}]}], styleFromRow, oldLast, newLast } } — 저장은 writer.js
  function convert(target, dayBooks, agms) {
    const sensorTabs = {};
    target.worksheets.forEach((ws) => { const s = normSensor(ws.name); if (s && !DATE_TAB.test(ws.name)) sensorTabs[s] = ws; });
    let recs = [];
    const readTabs = [];
    [target, ...dayBooks].forEach((wb) => wb.worksheets.forEach((ws) => {
      if (DATE_TAB.test(ws.name)) { recs = recs.concat(readDateSheet(ws)); readTabs.push(ws.name.trim()); }
    }));
    recs.sort((a, b) => (a.mmdd + a.hm).localeCompare(b.mmdd + b.hm));
    const unknown = [...new Set(recs.filter((r) => !sensorTabs[r.sensor]).map((r) => r.sensor))];
    const report = [], missingAgms = [], plan = {};
    Object.entries(sensorTabs).forEach(([s, ws]) => {
      const have = new Set();
      for (let r = 3; r <= ws.rowCount; r++) { const n = normNo(val(ws.getRow(r).getCell(1))); if (n) have.add(n); }
      const oldLast = lastFilledRow(ws);
      let r = oldLast;
      const rows = [];
      recs.filter((x) => x.sensor === s && !have.has(x.no)).forEach((x) => {
        r += 1;
        const key = `${x.mmdd.slice(0, 2)}-${x.mmdd.slice(2)} ${x.hm}`;
        const ag = agms && agms[s] ? agms[s][key] : undefined;
        if (ag === undefined) missingAgms.push(`${s} ${key}`);
        const [h, m] = x.hm.split(":").map(Number);
        const num = (v) => (v === null || v === undefined || v === "" ? null : (typeof v === "number" ? v : (isNaN(Number(v)) ? v : Number(v))));
        const cell = (col, v, kind) => ({ col, v, kind: kind || (typeof v === "number" ? "number" : "string") });
        rows.push({ r, cells: [
          cell(1, /^\d+$/.test(x.no || "") ? Number(x.no) : x.no),
          cell(2, (h * 60 + m) / 1440, "number"),
          cell(3, num(x.ysi)), cell(4, num(x.s1)), cell(5, num(x.s2)), cell(6, num(x.s3)),
          cell(7, `AVERAGE(D${r}:F${r})`, "formula"),
          cell(9, ag === undefined ? null : ag, "number"),
        ] });
        have.add(x.no);
      });
      report.push({ tab: ws.name, added: rows.length });
      if (rows.length) plan[ws.name] = { rows, styleFromRow: Math.max(oldLast, 3), oldLast, newLast: r };
    });
    return { plan, report, unknown, missingAgms, readTabs };
  }

  const api = { convert, parseGlucoseCsv, normSensor, readDateSheet };
  if (typeof module !== "undefined") module.exports = api; else root.XConv = api;
})(this);
